import { Chip } from "@mui/material";
import { STATUS_GERADA_LABEL, type Gerada } from "@/api/escala.service";

const STATUS_CHIP_COLOR: Record<Gerada["status"], "default" | "warning" | "success" | "error"> = {
  RASCUNHO: "default",
  VALIDADA: "warning",
  APROVADA: "success",
  CANCELADA: "error",
  REMOVIDA: "default",
};

export function StatusGeradaChip({ status }: { status: Gerada["status"] }) {
  return <Chip size="small" label={STATUS_GERADA_LABEL[status]} color={STATUS_CHIP_COLOR[status]} />;
}
